import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    postBillingCreateInvoices: build.mutation({
      query: body => ({ url: '/api/v1/billing/invoice', method: 'POST', body }),
    }),
  }),
})

export const { usePostBillingCreateInvoicesMutation } = extendedApi
